import { memo, useCallback } from 'react'
import MaterialSymbolsPlayArrow from '~icons/material-symbols/play-arrow'
import MaterialSymbolsStop from '~icons/material-symbols/stop'
import classNames from 'classnames'

export const AudioState = {
  disabled: 'disabled',
  stopped: 'stopped',
  playing: 'playing',
} as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AudioState = (typeof AudioState)[keyof typeof AudioState]

export type EventRecordingTranscribeAudioPlayButtonProps = {
  // イベント録画文字起こしID
  eventRecordingTranscribeId: string
  // 再生開始時刻
  speechTimestamp: number
  // 次の文字起こしの開始時刻
  // 音声の再生時間制御に使用する
  // TODO: CREW-19010 で削除予定
  // https://break-tmc.atlassian.net/browse/CREW-19010
  nextSpeechTimestamp: number | null
  // 音声再生制御
  audioState: AudioState
  audioCurrentRequester: string | null
  audioPlay?: (requester: string, start: number, end: number | null) => void
  audioStop?: () => void
}

export const EventRecordingTranscribeAudioPlayButton = memo(
  (props: EventRecordingTranscribeAudioPlayButtonProps) => {
    // このコンポーネントから音声を再生しているか否か
    const isCurrentlyPlayingSound =
      props.audioState === AudioState.playing &&
      props.audioCurrentRequester === props.eventRecordingTranscribeId

    // 再生・停止ボタンクリック時
    const handlePlayStopButtonClick = useCallback(() => {
      if (props.audioState === AudioState.disabled) {
        // 無効な状態でクリックされた場合は何もしない
        return
      }

      if (isCurrentlyPlayingSound) {
        // このコンポーネントから再生中の場合は停止する(停止ボタン)
        props.audioStop?.()
      } else {
        // このコンポーネントから再生中でない場合は再生を開始する(再生ボタン)

        const startTime = Math.max(
          // 0未満は0にcripする
          (props.speechTimestamp ?? 0) - 1, // 誤差を考え、1秒早く再生開始する
          0
        )
        const endTime = props.nextSpeechTimestamp
          ? props.nextSpeechTimestamp + 1 // 誤差を考え、1秒遅くまで再生する
          : null

        props.audioPlay?.(props.eventRecordingTranscribeId, startTime, endTime)
      }
    }, [isCurrentlyPlayingSound, props])

    return (
      <div
        className={classNames(
          props.audioState !== AudioState.disabled
            ? 'cursor-pointer hover:opacity-70'
            : 'opacity-70'
        )}
        onClick={handlePlayStopButtonClick}
      >
        {isCurrentlyPlayingSound ? (
          <MaterialSymbolsStop width={24} height={24} />
        ) : (
          <MaterialSymbolsPlayArrow width={24} height={24} />
        )}
      </div>
    )
  }
)
